export default __webpack_public_path__ + "static/Montserrat-Regular-24785cc015b27a3e964be934a8906023.ttf";